import React from "react";

export default function Modal({ open, title, children, onClose, footer, className = "", dialogClassName = "" }) {
  if (!open) return null;

  return (
    <div className={`agent-modal-root ${className}`.trim()} role="dialog" aria-modal="true">
      <div className="agent-modal-backdrop" onClick={onClose} />
      <div className={`modal-dialog modal-dialog-centered ${dialogClassName}`.trim()}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title mb-0">{title}</h5>
            <button type="button" className="btn-close" aria-label="Close" onClick={onClose} />
          </div>
          <div className="modal-body agent-modal-body">{children}</div>
          {footer ? <div className="modal-footer">{footer}</div> : null}
        </div>
      </div>
    </div>
  );
}
